import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, CheckCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function ResetPasswordPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError("As passwords não coincidem.");
      return;
    }
    if (password.length < 6) {
      setError("A password deve ter pelo menos 6 caracteres.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await axios.post(`${API}/auth/reset-password`, { token, new_password: password });
      setSuccess(true);
    } catch (err) {
      setError(err?.response?.data?.detail || "Token inválido ou expirado.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) {
    return (
      <main className="pt-32 pb-20 bg-stone-50 min-h-screen">
        <div className="max-w-md mx-auto px-6 text-center">
          <p className="text-stone-500">Link inválido. Pede um novo link de recuperação.</p>
          <Link to="/area-socio/forgot-password" className="text-brand-700 font-semibold mt-4 inline-block">
            Recuperar password
          </Link>
        </div>
      </main>
    );
  }

  if (success) {
    return (
      <main className="pt-32 pb-20 bg-stone-50 min-h-screen">
        <div className="max-w-md mx-auto px-6">
          <div className="bg-white rounded-2xl shadow-xl border border-stone-100 p-8 text-center">
            <CheckCircle className="w-16 h-16 text-green-500 mx-auto mb-4" />
            <h1 className="text-2xl font-bold text-stone-900 mb-2">Password Redefinida!</h1>
            <p className="text-stone-500 mb-6">A tua password foi alterada com sucesso.</p>
            <Link to="/area-socio/login" className="inline-flex items-center gap-2 bg-brand-700 text-white rounded-full py-3 px-8 font-semibold hover:bg-brand-800">
              Iniciar Sessão
            </Link>
          </div>
        </div>
      </main>
    );
  }

  return (
    <main className="pt-32 pb-20 bg-stone-50 min-h-screen">
      <div className="max-w-md mx-auto px-6">
        <div className="bg-white rounded-2xl shadow-xl border border-stone-100 p-8">
          <h1 className="text-2xl font-bold text-stone-900 mb-2 text-center">Nova Password</h1>
          <p className="text-stone-500 text-sm text-center mb-6">Escolhe uma nova password.</p>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="text-sm font-medium text-stone-700 mb-1.5 block">Nova password</label>
              <input required type="password" value={password} onChange={e => setPassword(e.target.value)}
                placeholder="••••••••" minLength={6}
                className="w-full h-10 px-3 rounded-md border border-stone-200 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
            </div>
            <div>
              <label className="text-sm font-medium text-stone-700 mb-1.5 block">Confirmar password</label>
              <input required type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                placeholder="••••••••"
                className="w-full h-10 px-3 rounded-md border border-stone-200 text-sm bg-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent" />
            </div>

            {error && <p className="text-sm text-red-600">{error}</p>}

            <button type="submit" disabled={loading}
              className="w-full bg-brand-700 hover:bg-brand-800 disabled:opacity-60 text-white rounded-full py-3 font-semibold">
              {loading ? "A redefinir..." : "Redefinir Password"}
            </button>
          </form>
        </div>
      </div>
    </main>
  );
}
